class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productInfoRequestId = 0;
    this.productInfoAbortController = null;
    this.addEventListener('change', this.onVariantChange);
    requestAnimationFrame(() => {
      if (!this.isConnected || !this.querySelector('[type="application/json"]')) return;
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantStatuses();
      this.updateAvailabilityGuidance();
    });
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateAvailabilityGuidance();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    const mediaItemId = `item-${this.currentVariant.featured_media.id}`;
    const thumbnailItemId = `thumbnail-item-${this.currentVariant.featured_media.id}`;
    const mediaItem = document.getElementById(mediaItemId);
    const thumbnailItem = document.getElementById(thumbnailItemId);

    if (mediaGridySlider && mediaItem && mediaGridySlider.contains(mediaItem)) {
      mediaGridySlider.scrollToSlideByID(
        mediaItemId
      );
    }

    if (thumbnailsGridySlider && thumbnailItem && thumbnailsGridySlider.contains(thumbnailItem)) {
      thumbnailsGridySlider.scrollToSlideByID(thumbnailItemId);
    }

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const isGrid = mediaGridySlider?.dataset.desktopEnabled === 'false';
    if (isDesktop && isGrid && mediaItem) {
      mediaItem.scrollIntoView();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const nextUrl = new URL(window.location.href);
    nextUrl.pathname = this.dataset.url;
    nextUrl.searchParams.set('variant', this.currentVariant.id);
    window.history.replaceState({ }, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    const selectedValues = inputWrappers.map((wrapper) => {
      const selectedInput = wrapper.querySelector('input[type="radio"]:checked, select');
      return selectedInput ? selectedInput.value : null;
    });

    inputWrappers.forEach((option, optionIndex) => {
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const availableOptionInputsValue = optionInputs
        .filter((input) => this.variantData.some((variant) => {
          if (!variant.available) return false;

          return variant.options.every((variantValue, variantOptionIndex) => {
            if (variantOptionIndex === optionIndex) {
              return variantValue === input.value;
            }

            return !selectedValues[variantOptionIndex] || variantValue === selectedValues[variantOptionIndex];
          });
        }))
        .map((input) => input.value);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  updateAvailabilityGuidance() {
    const guidance = this.querySelector('[data-variant-availability-guidance]');
    if (!guidance) return;

    if (this.currentVariant && this.currentVariant.available) {
      guidance.textContent = '';
      guidance.hidden = true;
      return;
    }

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    const selectedValues = inputWrappers.map((wrapper) => {
      const selectedInput = wrapper.querySelector('input[type="radio"]:checked, select');
      return selectedInput ? selectedInput.value : null;
    });
    const sizeIndex = inputWrappers.findIndex((wrapper) => {
      const optionName = wrapper.querySelector('input[type="radio"], select')?.name || '';
      return /size/i.test(optionName);
    });
    const colourIndex = inputWrappers.findIndex((wrapper) => {
      const optionName = wrapper.querySelector('input[type="radio"], select')?.name || '';
      return /colou?r/i.test(optionName);
    });

    if (sizeIndex > -1) {
      const availableSizes = [...new Set(this.variantData
        .filter((variant) => variant.available && variant.options.every((variantValue, optionIndex) => {
          return optionIndex === sizeIndex || !selectedValues[optionIndex] || variantValue === selectedValues[optionIndex];
        }))
        .map((variant) => variant.options[sizeIndex]))];
      const colourName = colourIndex > -1 ? selectedValues[colourIndex] : null;

      if (availableSizes.length) {
        guidance.textContent = `${colourName ? `${colourName} is` : 'This style is'} available in ${availableSizes.join(', ')}. Choose an available size.`;
      } else {
        guidance.textContent = `${colourName ? `${colourName} is` : 'This selection is'} currently sold out in every size.`;
      }
    } else {
      guidance.textContent = 'This combination is unavailable. Choose another option.';
    }

    guidance.hidden = false;
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const sourceSectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const requestId = this.productInfoRequestId + 1;
    this.productInfoRequestId = requestId;
    this.productInfoAbortController?.abort();
    this.productInfoAbortController = new AbortController();

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sourceSectionId}`, {
      signal: this.productInfoAbortController.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Product section request failed with ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        if (requestId !== this.productInfoRequestId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${sourceSectionId}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${sourceSectionId}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${sourceSectionId}`);

        this.refreshSelectedColourGallery(html, sourceSectionId);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (buyBarInfoSource && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .catch((error) => {
        if (error.name === 'AbortError' || requestId !== this.productInfoRequestId) return;

        console.error('Unable to refresh product information.', error);
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .finally(() => {
        if (requestId === this.productInfoRequestId) this.productInfoAbortController = null;
      });
  }

  refreshSelectedColourGallery(html, sourceSectionId) {
    if (sourceSectionId !== this.dataset.section) return;

    const destinationMediaSlider = document.getElementById(`slider-${this.dataset.section}`);
    const sourceMediaSlider = html.getElementById(`slider-${sourceSectionId}`);

    if (!destinationMediaSlider || !sourceMediaSlider) return;
    if (destinationMediaSlider.dataset.clMediaGalleryRefresh !== 'true') return;
    if (sourceMediaSlider.dataset.clMediaGalleryRefresh !== 'true') return;
    if (destinationMediaSlider.dataset.clMediaScopeKey === sourceMediaSlider.dataset.clMediaScopeKey) return;

    const destinationThumbnailSlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    const sourceThumbnailSlider = html.getElementById(`thumbnail-slider-${sourceSectionId}`);
    const destinationZoomModal = document.getElementById('modal--zoom-gallery');
    const sourceZoomModal = html.getElementById('modal--zoom-gallery');
    const hasMatchingThumbnails = Boolean(destinationThumbnailSlider) === Boolean(sourceThumbnailSlider);
    const hasMatchingZoomModal = Boolean(destinationZoomModal) === Boolean(sourceZoomModal);

    if (!hasMatchingThumbnails || !hasMatchingZoomModal) return;
    if (sourceThumbnailSlider?.dataset.clMediaGalleryRefresh !== 'true') return;
    if (sourceZoomModal?.dataset.clMediaGalleryRefresh !== 'true') return;

    const destinationZoomColumn = destinationZoomModal?.querySelector('.modal-gallery-column');
    const sourceZoomColumn = sourceZoomModal?.querySelector('.modal-gallery-column');
    if (Boolean(destinationZoomColumn) !== Boolean(sourceZoomColumn)) return;

    const nextMediaSlider = sourceMediaSlider.cloneNode(true);
    const nextThumbnailSlider = sourceThumbnailSlider?.cloneNode(true);

    destinationMediaSlider.replaceWith(nextMediaSlider);
    if (destinationThumbnailSlider && nextThumbnailSlider) {
      destinationThumbnailSlider.replaceWith(nextThumbnailSlider);
    }

    if (destinationZoomColumn && sourceZoomColumn) {
      destinationZoomColumn.replaceChildren(
        ...Array.from(sourceZoomColumn.childNodes, (node) => node.cloneNode(true))
      );
      destinationZoomModal.dataset.clMediaScopeKey = sourceZoomModal.dataset.clMediaScopeKey;
    }

    this.bindRefreshedGalleryZoom(nextMediaSlider);

    requestAnimationFrame(() => {
      if (nextMediaSlider.config && nextThumbnailSlider) {
        nextMediaSlider.config.thumbnail_slider = nextThumbnailSlider;
      }
      if (nextThumbnailSlider?.config) {
        nextThumbnailSlider.config.thumbnails_for = nextMediaSlider;
      }
      this.updateMedia();
    });
  }

  bindRefreshedGalleryZoom(mediaSlider) {
    const zoomButton = mediaSlider.querySelector('.zoom-button');
    if (!zoomButton) return;

    zoomButton.addEventListener('click', (event) => {
      const zoomModal = document.getElementById('modal--zoom-gallery');
      const activeSlide = mediaSlider.querySelector('.active') || mediaSlider.querySelector('[id^="item-"]');
      const zoomSlide = activeSlide ? document.getElementById(`modal-${activeSlide.id}`) : null;
      const galleryDialog = zoomModal?.querySelector('.modal-dialog');

      if (window.Woolman?.ModalsAndDrawers?.showModalOrDrawer) {
        event.preventDefault();
        window.Woolman.ModalsAndDrawers.showModalOrDrawer('modal--zoom-gallery');
      }

      if (zoomSlide && galleryDialog) {
        galleryDialog.scrollTo({
          top: zoomSlide.offsetTop,
          behavior: 'instant',
        });
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.removeAttribute('disabled');
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (this.dataset.isPreorder == "true") {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

class UpsellProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          //debugger
          const recommendations = html.querySelector('upsell-product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('upsell-product-recommendations', UpsellProductRecommendations);
